import { Component, Vue } from 'vue-facing-decorator';;
import { ElMessage, ElMessageBox } from 'element-plus';
import { UserFilled, Lock } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import AuthService from '@/services/AuthService';
import ApiService from '@/services/ApiService';

interface PasswordForm
{
    newPassword: string;
    repeatPassword: string;
}

@Component(
{
    components:
    {
        Header,
        Navigation,
        Breadcrumbs,
        UserFilled,
        Lock
    },
    enums:
    {
        NavigationIndex
    }
})

export default class UserProfile extends Vue 
{
    private loadingPassword : boolean = true;
    private formPasswordValid: boolean = false;
    private oldPassword: string = '';
    private newPassword: string = '';
    private repeatPassword: string = '';
    private userModel: UserModel | undefined = {} as UserModel;
    private passwordForm: PasswordForm = {} as PasswordForm;
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;
    private rules =
    {
        newPassword:
        [
            {
                required: true,
                message: "Bitte geben Sie ein neues Passwort ein.",
                trigger: "blur"
            }
        ],
        repeatPassword:
        [
            {
                required: true,
                message: "Bitte wiederholen Sie das neue Passwort.",
                trigger: "blur"
            }
        ]
    };

    public async mounted()
    {
        let userid : string = localStorage.getItem("auth");

        if (userid > 0)
        {
            this.userModel = await ApiService.getUser(userid);
            if (this.userModel)
            {
                // check if a password has been set yet
                this.oldPassword = this.userModel.password;
                this.loadingPassword = false;
            }
        }

        window.addEventListener('resize', this.onWindowResize);
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async savePassword(user: UserModel)
    {
        this.loadingPassword = true;

        let ok: any = await ApiService.patchUser(user);

        if (ok)
        {
            ElMessage({message: "Das neue Passwort wurde gespeichert.", type: 'success'});
            this.oldPassword = this.userModel!.password;
        }
        else
        {
            // or show error message
            ElMessage({message: "Das neue Passwort konnte nicht gespeichert werden.", type: 'error'});
        }

        this.loadingPassword = false;
    }

    private validatePasswordForm() : boolean
    {
        if (!this.passwordForm.newPassword || this.passwordForm.newPassword.length <= 0) return false;

        if (!this.passwordForm.repeatPassword || this.passwordForm.repeatPassword.length <= 0) return false;

        if (this.passwordForm.repeatPassword.length == this.passwordForm.newPassword.length)
        {
            if (this.passwordForm.repeatPassword !== this.passwordForm.newPassword)
            {
                ElMessage({message: "Die Passwörter stimmen nicht überein. Bitte prüfen Sie die Eingaben.", type: 'error'});
                return false;
            }
        }
        else
        {
            return false;
        }

        return true;
    }

    private onInput()
    {
        this.formUserValid = this.validateUserForm();
    }

    private onPasswordInput()
    {
        this.formPasswordValid = this.validatePasswordForm();
    }

    private onPasswordSaveClick()
    {
        if (this.userModel)
        {
            this.userModel.password = this.passwordForm.newPassword;
            this.savePassword(this.userModel);
        }
    }
}
